import md5 from "crypto-js/md5";

export function SocialEmailLink(fullName, url) {
    return "mailto:?subject=" + encodeURIComponent(fullName) + "&body=" + encodeURIComponent(`This is the ${fullName}:\n\n${url}\n\nWhat is Meal Train?\nThere are times in our lives when friends and family ask, "What can I do to help out?" The answer is usually to help them with a meal. When many friends provide support through a meal, Meal Train keeps everyone organized.\n\nMealTrain.com is a free meal calendar tool that makes planning meals among a wide group easy and less stressful.\n\nPlease share this email with others.`);
}

export function SocialTwitterLink(fullName, url) {
    return "https://twitter.com/intent/tweet?text=" + encodeURIComponent(fullName) + "&url=" + encodeURIComponent(url) + "&via=mealtrain";
}

export function SocialFacebookLink(url) {
    return "https://www.facebook.com/dialog/share?app_id=104590689638094&display=page&href=" + encodeURIComponent(url);
}

// Note: keep in sync with SocialHelper.cs
export function SocialFacebookPhoto(id) {
    return "https://graph.facebook.com/" + id + "/picture?type=large&access_token=104590689638094|d4074a6db429912fad0cd0cc2de2b1d3";
}

export function SocialGravatarHash(email) {
    const hash = md5(email.toLowerCase().trim()) + "";
    return hash;
}

// Note: keep in sync with SocialHelper.cs
export function SocialGravatarPhoto(hash) {
    return "https://www.gravatar.com/avatar/" + hash + "?s=200&d=404&r=pg";
}